module.exports = __webpack_public_path__ + "static/finance-option-back-927018affa9e68e42a2836fed2e8dd40.png";